import React from 'react';
import { useNavigate } from "react-router-dom";
import { AppBar, Divider, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { MenuItem, Typography } from '@mui/material';
import HPlusMobiledataIcon from '@mui/icons-material/HPlusMobiledata';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { FormMode, USysObjects } from '../utils/extensions/constantEx'
import { HomeContext } from '../utils/contexts/homeContext';
import { useCookies } from 'react-cookie'

const settings = ['Change Password', 'Logout'];
// const settings = ['Logout'];

function AppToolBar(props) {
    const { isUserLogged, handleOpenChangePassword } = props;
    const { homeState, ClearLoggedUser, SetAccountPersonIcon } = React.useContext(HomeContext);

    const navigate = useNavigate();

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorToolMenu, setAnchorToolMenu] = React.useState(null);
    const [anchorNurseMenu, setAnchorNurseMenu] = React.useState(null);
    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    const isToolMenuOpen = Boolean(anchorToolMenu);
    const isNurseMenuOpen = Boolean(anchorNurseMenu);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleOpenToolMenu = (event) => {
        setAnchorToolMenu(event.currentTarget);
    };

    const handleOpenNurseMenu = (event) => {
        setAnchorNurseMenu(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleCloseToolMenu = () => {
        setAnchorToolMenu(null);
    };

    const handleCloseManageMenu = () => {
        setAnchorNurseMenu(null);
    };

    const handleSearchServices = () => {
        console.log('homeState', homeState.loggedUser.objectRights);
        handleCloseManageMenu();
        handleCloseNavMenu();
        navigate("/search-services", { replace: false });
    }

    const handleSearchNurses = () => {
        handleCloseManageMenu();
        handleCloseNavMenu();
        navigate("/search-nurses", { replace: false });
    }

    const handleSearchNurseServiceBooking = () => {
        handleCloseManageMenu();
        handleCloseNavMenu();
        navigate("/nurse-service-booking", { replace: false });
    }

    const handleAddNewNurse = () => {
        handleCloseManageMenu();
        handleCloseNavMenu();

        navigate("/nurse-form", {
            replace: false, state: {
                formMode: FormMode.NewMode,
                from: 'nurse-search',
                selectedId: 0
            }
        });
    }

    const handleAddServiceBooking = () => {
        handleCloseManageMenu();
        handleCloseNavMenu();

        navigate("/nurse-service-booking-form", { replace: false });
    }

    const handleSettingMenuClick = (menuName) => {
        handleCloseUserMenu();

        switch (menuName) {
            case 'Logout':
                const logInUrl = "/user-login?ccd=" + homeState.loggedUser.ccd;
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
                SetAccountPersonIcon(null);
                navigate(logInUrl, { replace: false });
                break;

            case 'Change Password':
                handleOpenChangePassword();
                break;
        }
    }

    const handleEmployeeSearch = () => {
        handleCloseManageMenu();
        handleCloseToolMenu();
        navigate("/search-employees", { replace: false });
    }

    return (
        <AppBar position="static">
            <Toolbar disableGutters sx={{ mr: '10px', ml: '10px' }}>
                <HPlusMobiledataIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, fontSize: '50px' }} />
                <Typography
                    variant="h6"
                    noWrap
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    HomeCare
                </Typography>

                {
                    isUserLogged &&
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_add_new) &&
                                <MenuItem onClick={handleAddNewNurse}>New Nurse</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new) &&
                                <MenuItem onClick={handleAddServiceBooking}>New Service Booking</MenuItem>
                            }
                            {
                                (homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_add_new)
                                    || homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new)) &&
                                <Divider />
                            }

                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_read) &&
                                <MenuItem onClick={handleSearchServices}>Services</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_read) &&
                                <MenuItem onClick={handleSearchNurses}>Nurses</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_read) &&
                                <MenuItem onClick={handleSearchNurseServiceBooking}>Service Booking</MenuItem>
                            }
                            {
                                (homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_read)
                                    || homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_read)
                                    || homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_read)) &&
                                <Divider />
                            }

                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Employees && col.is_read) &&
                                <MenuItem onClick={handleEmployeeSearch}>Employees</MenuItem>
                            }

                        </Menu>
                    </Box>
                }

                <HPlusMobiledataIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1, fontSize: '50px' }} />
                <Typography
                    variant="h5"
                    noWrap
                    sx={{
                        mr: 2,
                        display: { xs: 'flex', md: 'none' },
                        flexGrow: 1,
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    HomeCare
                </Typography>

                <Box sx={{ flexGrow: 0.2, display: { xs: 'none', md: 'flex' } }}></Box>

                {
                    isUserLogged &&
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Button key={"toolMenu"} sx={{ color: 'white', display: 'block' }}
                            onClick={handleOpenNurseMenu}
                        >
                            Manage
                        </Button>

                        <Menu
                            id="basic-menu"
                            anchorEl={anchorNurseMenu}
                            open={isNurseMenuOpen}
                            onClose={handleCloseManageMenu}
                            slotProps={{

                            }}
                        >
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_add_new) &&
                                <MenuItem onClick={handleAddNewNurse}>New Nurse</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new) &&
                                <MenuItem onClick={handleAddServiceBooking}>New Service Booking</MenuItem>
                            }
                            {
                                (homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_add_new)
                                    || homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_add_new)) &&
                                <Divider />
                            }

                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServices && col.is_read) &&
                                <MenuItem onClick={handleSearchServices}>Services</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Nurses && col.is_read) &&
                                <MenuItem onClick={handleSearchNurses}>Nurses</MenuItem>
                            }
                            {
                                homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.PatientServiceBookings && col.is_read) &&
                                <MenuItem onClick={handleSearchNurseServiceBooking}>Service Booking</MenuItem>
                            }
                            {/* {
                                (homeState.loggedUser.objectRights.filter(col => col.object_id === USysObjects.PatientServices && col.is_read)
                                    || homeState.loggedUser.objectRights.filter(col => col.object_id === USysObjects.Nurses && col.is_read)
                                    || homeState.loggedUser.objectRights.filter(col => col.object_id === USysObjects.PatientServiceBookings && col.is_read)) &&
                                <Divider />
                            } */}
                        </Menu>

                        {
                            homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Employees && col.is_read) &&
                            <Button key={"toolMenu"} sx={{ pl: 5, color: 'white', display: 'block' }}
                                onClick={handleOpenToolMenu}
                            >
                                Tools
                            </Button>
                        }
                        {
                            homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Employees && col.is_read) &&
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorToolMenu}
                                open={isToolMenuOpen}
                                onClose={handleCloseToolMenu}
                                slotProps={{

                                }}
                            >
                                {
                                    homeState.loggedUser.objectRights.find(col => col.object_id === USysObjects.Employees && col.is_read) &&
                                    <MenuItem onClick={handleEmployeeSearch}>Employees</MenuItem>
                                }
                            </Menu>
                        }
                    </Box>
                }

                <Box sx={{ flexGrow: 0 }}>
                    {
                        isUserLogged &&
                        <Stack direction="row" spacing={1}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <Typography variant="subtitle2">
                                    {homeState.loggedUser.fullName}
                                </Typography>
                            </Box>

                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
                                    <AccountCircleIcon sx={{ fontSize: 40, color: '#fff' }} />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    }
                    {
                        homeState.loggedUser.isUserLogged &&
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={() => handleSettingMenuClick(setting)}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    }
                </Box>
            </Toolbar>
        </AppBar>
    );
}
export default AppToolBar;